export default "__VITE_ASSET__XmQTMsdC__"